import fetchVariables from "./fetch-variables";
import saveVariables from "./save-variables";
export default {
    fetchVariables,
    saveVariables,
};
